import { useCallback, useReducer } from "react";
import AlertModalV2Reducer from "./reducer";
import { Button, Icon, SubTitle } from "@dspworkplace/ui";
import { ScrollyModalStyleV2, ScrollyOverlayStyleV2 } from "../GlobalOverrideStyled";

const initialState = {
    show: false,
    okText: "OK",
    cancelText: "CANCEL",
    title: "Alert",
    textKind: "Default",
    textArray: [""],
    buttonNumber: 1,
    type: "",
};

export function useAlertModalV2Reducer() {
    const [state, dispatch] = useReducer(AlertModalV2Reducer, initialState);

    const closeModal = useCallback(() => {
        dispatch({ type: "closeModal" });
    }, []);

    const openYesNo = (textArr) => {
        dispatch({
            type: "openYes&No",
            textArray: textArr,
        });
    };

    const closeText = (textArr) => {
        dispatch({
            type: "closeText",
            textArray: textArr,
        });
    };

    const setTitle = (titleValue) => {
        dispatch({
            type: "title",
            title: titleValue,
        });
    };

    return { state, dispatch, closeModal, openYesNo, closeText, setTitle };
}

const AlertModalV2 = ({
    show,
    okText = "OK",
    cancelText = "CANCEL",
    title = "Alert",
    textKind = "Default",
    textArray = [""],
    okCallback,
    cancelCallback,
    buttonNumber = 2,
    dismissCallback,
}) => {
    if (!show) return null;

    return (
        <ScrollyOverlayStyleV2
            onClick={(e) => {
                if (e.target === e.currentTarget && typeof dismissCallback === "function") {
                    dismissCallback();
                }
            }}
        >
            <ScrollyModalStyleV2 width="95%">
                <header className="modalHeader">
                    <SubTitle style={{ color: "#00538a", fontSize: "20px", fontWeight: 700 }}>
                        {title}
                    </SubTitle>

                    <button
                        className="close"
                        onClick={cancelCallback}
                        style={{ background: "none", border: "none", cursor: "pointer" }}
                    >
                        <Icon.TimesV2 color="none" stroke="#62748e" size="20px" strokeColor="#62748e" />
                    </button>
                </header>

                <div className="inspectionModal">
                    {textKind === "Default" &&
                        textArray.map((item, index) => (
                            <div key={index}>
                                {textArray.length > 1 && (
                                    <span>-</span>
                                )}
                                <span>{item}</span>
                            </div>
                        ))}

                    {textKind === "No-Hyphen" &&
                        textArray.map((item, index) => (
                            <div key={index}>
                                <span>{item}</span>
                            </div>
                        ))}
                </div>

                <footer className="modalFooter">
                    {buttonNumber === 2 && (
                        <>
                            <Button type="cancel" onClick={cancelCallback}>{cancelText}</Button>
                            <Button type="primary" Type="submit" onClick={okCallback}>
                                {okText}
                            </Button>
                        </>
                    )}

                    {buttonNumber === 1 && (
                        <Button type="primary" Type="submit" onClick={okCallback}>
                            {okText}
                        </Button>
                    )}
                </footer>
            </ScrollyModalStyleV2>
        </ScrollyOverlayStyleV2>
    );
};

export default AlertModalV2;